<template>
  <div class="main_head_block">
    <div class="row head_block">
      <p class="module_bread">{{selectedModule||'Campaigns'}}</p>
      <p class="bread_crumb">
        <a
              href="javascript:void(0)"
              style="color:#000000"
              @click="back()"
              v-if="tabCalled"
              >{{tabCalled +' >'}}</a
            >
            <span
              style="font-weight:bold;padding-left:5px;"
              >{{ selectedName }}</span
            >
            <span class="detail-data" v-if="showLabel">
							<p style = "text-transform:capitalize" class="label label-info">{{labelName}}
							</p>
						</span>
            <a  href="javascript:void(0)"
              style="color:#000000;float:right;padding-right:10px"
              v-if="showEdit"
              @click="edit()">Edit</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props:['selectedName','tabCalled','selectedModule','showEdit','showLabel','labelName'],
  methods:{
    back(){
      this.$emit('backCalled')
    },
    edit(){
      this.$emit('editCalled')
    }
  }
};
</script>
<style lang='scss'>
.main_head_block {
  .head_block {
    .module_bread {
      padding-top: 25px;
      height: 29px;
      color: #000000;
      font-family: Poppins;
      font-size: 21px;
      font-weight: 500;
      letter-spacing: -0.02px;
      line-height: 31px;
      width:100%;
    }
    .bread_crumb{
      width:100%;
      padding-top: 7px;
      height: 22px;
      color: #000000;
      font-family: "Nunito Sans";
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 22px;
      margin-bottom:0px;
    }
  }
}
</style>